var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoNovuUnreadNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28572 0C1.86556 0 0.714294 1.15127 0.714294 2.57143V12.8571L0.714328 12.8704C0.721443 14.2844 1.86997 15.4286 3.28572 15.4286H10.3572C10.7122 15.4286 11 15.1408 11 14.7857C11 14.4307 10.7122 14.1429 10.3572 14.1429H3.28572C2.69063 14.1429 2.18997 13.7386 2.04342 13.1897L9.29537 8.72691L11 9.74969L20 4.34969V8.35714C20 8.71218 20.2878 9 20.6429 9C20.9979 9 21.2857 8.71218 21.2857 8.35714V2.57143C21.2857 1.15127 20.1345 0 18.7143 0H3.28572ZM8.05325 7.98164L2.00001 11.7067V4.34969L8.05325 7.98164ZM2.00001 2.85031V2.57143C2.00001 1.86135 2.57564 1.28571 3.28572 1.28571H18.7143C19.4244 1.28571 20 1.86135 20 2.57143V2.85031L11 8.25031L2.00001 2.85031Z",
    fill: "#1C2743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7857 18C19.271 18 21.2857 15.9853 21.2857 13.5C21.2857 11.0147 19.271 9 16.7857 9C14.3004 9 12.2857 11.0147 12.2857 13.5C12.2857 15.9853 14.3004 18 16.7857 18ZM17.4286 11.5714V13.5C17.4286 13.855 17.1408 14.1429 16.7857 14.1429C16.4307 14.1429 16.1429 13.855 16.1429 13.5V11.5714C16.1429 11.2164 16.4307 10.9286 16.7857 10.9286C17.1408 10.9286 17.4286 11.2164 17.4286 11.5714ZM17.4286 15.4286C17.4286 15.7836 17.1408 16.0714 16.7857 16.0714C16.4307 16.0714 16.1429 15.7836 16.1429 15.4286C16.1429 15.0735 16.4307 14.7857 16.7857 14.7857C17.1408 14.7857 17.4286 15.0735 17.4286 15.4286Z",
    fill: "#1C2743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNovuUnreadNotifications);
export default __webpack_public_path__ + "static/media/ico-novu-unread_notifications.a6b5386f6e9e77f99efbaee371c095fc.svg";
export { ForwardRef as ReactComponent };